import { useInvalidConditionBeforeEstimateOrderQuery } from '@/graphql/generated/hooks'
import { store } from '@/stores/store'
import { Base64ConverterUtil } from '@/utils/base64-converter.util'
import { localEstimateTarget } from '@/utils/utilLocalStorage'

export const useInvalidConditionBeforeEstimateOrder = () => {
  const cartShippingGroups = store.getState().reduxDataReducers.estimatedOrderRequest || localEstimateTarget.load()

  const params =
    cartShippingGroups?.shippings
      .flatMap((shipping) => shipping.products)
      .map((product) => {
        const encodedProductOptionId = Base64ConverterUtil.convertNumberIdToBase64ByKey({
          key: 'ProductOptionType',
          id: product?.productOptionId,
        })
        return {
          productOption: encodedProductOptionId,
          quantity: product.quantity,
        }
      }) || []

  const {
    data: invalidConditionBeforeEstimateOrderQueryData,
    loading: isInvalidConditionBeforeEstimateOrderQueryDataLoading,
  } = useInvalidConditionBeforeEstimateOrderQuery({
    variables: {
      orderItems: params,
    },
    skip: !params.length,
  })

  const actionPowerProducts =
    invalidConditionBeforeEstimateOrderQueryData?.invalidConditionBeforeEstimateOrder?.actionPowerProducts

  const isInvalidOrderItems = actionPowerProducts && (actionPowerProducts.length ?? 0) >= 1

  return {
    actionPowerProducts,
    isInvalidConditionBeforeEstimateOrderQueryDataLoading,
    isInvalidOrderItems,
  }
}
